import React from "react";
import { Shell } from "../components/Shell";

const DOCS = {
    privacy: {
        eyebrow: "Privacy", title: "Privacy Policy",
        intro: "How WHY-AM collects, uses and protects your information. This is a plain-language summary and not legal advice; a formal legal review is recommended before launch.",
        sections: [
            ["What we collect", "Your account email and preferred name, your assessment answers, your generated report, your companion conversations, and optional memories you explicitly allow. We do not require a phone number."],
            ["Why we use it", "To generate your preview and report, to let the AI companion understand your situation, and to operate your account. We do not sell your data."],
            ["Consent", "We ask for separate consent to process your assessment answers and, optionally, to store long-term companion memory. You can withdraw consent at any time."],
            ["AI processing", "Your answers and messages are sent to a secure server-side AI provider to generate responses. We do not send your private answers or chats to general analytics tools."],
            ["Your controls", "You can view and delete saved memories, turn memory off, and request full deletion of your account and data from Profile → Account & privacy."],
            ["Data retention", "We keep your data while your account is active. On deletion, your answers, report, conversations and memories are removed from our database."],
            ["Contact", "For any privacy request, use the Contact & Support page."],
        ],
    },
    terms: {
        eyebrow: "Terms", title: "Terms of Service",
        intro: "The basics of using WHY-AM. This is a plain-language summary and not legal advice; a formal legal review is recommended before launch.",
        sections: [
            ["Who can use WHY-AM", "You must be 18 or older. WHY-AM is intended for adults seeking self-reflection."],
            ["What WHY-AM is", "A self-reflection tool that provides AI-generated reflections and a companion. It is not medical, psychological, legal or financial advice, and not a replacement for professional care."],
            ["No diagnosis or guarantees", "WHY-AM does not diagnose conditions, guarantee outcomes, or make claims about other people's intentions. Interpretations are offered as possibilities, not facts."],
            ["Payments", "The product is a one-time ₹299 payment, verified manually by the owner before access is granted. Submitting a reference or screenshot does not by itself grant access."],
            ["Acceptable use", "Do not misuse the service, attempt to access other users' data, or rely on it for emergencies. For urgent safety concerns, contact local emergency services."],
            ["Changes", "We may update these terms; continued use means acceptance of the current version."],
        ],
    },
    refund: {
        eyebrow: "Refunds", title: "Refund & Cancellation Policy",
        intro: "How refunds and cancellations work for the one-time ₹299 payment. This is a plain-language summary and not legal advice.",
        sections: [
            ["Before approval", "If your payment has not yet been approved and you wish to cancel, contact support. If the money has not been received or is returned, no access is granted and nothing further is owed."],
            ["After approval", "Because the full reflection and report become immediately available on approval, refunds after access is granted are considered case-by-case via the Contact page."],
            ["Failed or duplicate payments", "If you were charged but not granted access, or paid more than once, contact support with your transaction reference. Verified duplicate or erroneous payments will be refunded through the original method where possible."],
            ["How refunds are recorded", "A refund is only marked as completed after it has actually been executed and verified — never merely because it was requested."],
            ["Timeframes", "Refund processing times depend on your bank or payment provider."],
        ],
    },
};

export default function Legal({ doc }) {
    const d = DOCS[doc] || DOCS.privacy;
    return (
        <Shell eyebrow={d.eyebrow} title={d.title} intro={d.intro}>
            <div className="space-y-6">
                {d.sections.map(([h, b]) => (
                    <div key={h} className="card-soft p-6">
                        <h3 className="text-xl text-forest">{h}</h3>
                        <p className="mt-2 text-sm text-charcoal/75 leading-relaxed">{b}</p>
                    </div>
                ))}
            </div>
        </Shell>
    );
}
